import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const MasterLoadingDockRBAC = {
  pageID: '3c7c870973fac1fbae7daad3a8b7a1d0',
  elementID: {
    ViewMasterLoadingDock: '78c15ed3c726f50b8b1cdf276a70ac12',
    CreateLoadingDock: '7a0303806444c1c4e43d14c5eaa478d5',
    DeleteLoadingDock: 'f0aef6ea1e32f7fa94804a635b4474fe',
    SetMainLoadingDock: 'a496fefe076257b2fd2a69518d5839f0',
  },
} as const
export const useRBACMasterLoadingDock = createUseRBAC(MasterLoadingDockRBAC.elementID)
export type UseRBACMasterLoadingDockType = ReturnType<typeof useRBACMasterLoadingDock>

export const MasterTimeSlotRBAC = {
  pageID: '15535eb79314cbed7001840d1d4d1d30',
  elementID: {
    ViewMasterTimeSlot: '7cd2573f3ee74dec6c253af3b0d7a0be',
    EditTimeSlot: 'c34fda19d09592e3d20021e9521341d3',
    UpsertFCFS: '9c28b1764fbf2dd97278c38bfc88638d',
  },
} as const
export const useRBACMasterTimeSlot = createUseRBAC(MasterTimeSlotRBAC.elementID)
export type UseRBACMasterTimeSlotType = ReturnType<typeof useRBACMasterTimeSlot>

export const InboundScheduleRBAC = {
  pageID: 'f59259ed00e09a65ace0b8d097c8ce43',
  elementID: {
    ViewInboundSchedule: 'a0a76364aa779cca2a3f92723ecebab8',
    DeleteInboundSchedule: '6c605ba07982aca00838e7f966748f6a',
    CreateInboundSchedule: 'f44d323b8248bcbc18b87e5ce143c2dd',
    EditInboundSchedule: '844d5c7d00bc91597bc860c91c8feef1',
  },
} as const
export const useRBACInboundSchedule = createUseRBAC(InboundScheduleRBAC.elementID)
export type UseRBACInboundScheduleType = ReturnType<typeof useRBACInboundSchedule>

export const InboundScheduleUpsertRBAC = {
  pageID: '93da271b0384597cff22eb93854da84a',
  elementID: {
    ViewInboundScheduleUpsert: '50aa2a4180eccb8d3f7334a03aced53a',
    SubmitInboundSchedule: '815d066764e926ee42d59f0bf341ffba',
    RemovePoNumber: 'a62704f240da7fecfab9e29c7c310bbe',
    SendEmailPO: '9b9eae567fb0236ff3f0edd3b60c9ad3',
  },
} as const
export const useRBACInboundUpsertSchedule = createUseRBAC(InboundScheduleUpsertRBAC.elementID)
export type UseRBACInboundUpsertScheduleType = ReturnType<typeof useRBACInboundUpsertSchedule>
